import {
  collection,
  doc,
  QueryDocumentSnapshot,
  setDoc,
  Timestamp,
  updateDoc,
} from 'firebase/firestore';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { firestore } from 'services';
import { Button, Input } from 'shared/Components';
import { FlexContainer, Text } from 'shared/Typhography';
import styled from 'styled-components';

import { PayoutRequest } from '../PayoutRequestsScreen';

interface RejectRequestModalProps {
  close: (refreshDoc: boolean) => void;
  payoutRequest: QueryDocumentSnapshot<PayoutRequest>;
  user: { id: string; name: string; profileImage: string };
}

const ModalContainer = styled.div`
  background: white;
  border-radius: 12px;
  padding: 16px;
  box-sizing: border-box;
  max-width: 100%;
`;

interface FormInputs {
  reasoning?: string;
}

export default function RejectRequestModal({
  payoutRequest,
  close,
  user,
}: RejectRequestModalProps) {
  const { handleSubmit, control } = useForm<FormInputs>();

  const onSubmit = handleSubmit(async (data: FormInputs) => {
    if (!data?.reasoning) {
      toast.error('You have to fill all fields!');
      return;
    }

    try {
      const docRef = doc(firestore, `payoutRequests/${payoutRequest.id}`);

      await updateDoc(docRef, {
        updatedAt: Timestamp.now(),
        status: 'rejected',
      });

      const historyRef = collection(firestore, `payoutRequests/${payoutRequest.id}/history`);
      await setDoc(doc(historyRef), {
        actor: {
          id: user?.id,
          name: user?.name,
          profileImage: user?.profileImage,
        },
        createdAt: Timestamp.now(),
        updatedAttributes: ['status', 'reject'],
        updates: [
          {
            attribute: 'status',
            previousValue: payoutRequest?.data().status,
            value: 'rejected',
          },
          {
            attribute: 'reject',
            previousValue: null,
            value: data.reasoning,
          },
        ],
      });

      close(true);
    } catch (err) {
      toast.error('Something went wrong!');
      console.log(err);
    }
  });

  return (
    <ModalContainer id="hello-kitty">
      <FlexContainer flexDirection="column" gap="20px">
        <Text weight="bold">Payout Request reject</Text>

        <form
          style={{ marginTop: '50px' }}
          onSubmit={onSubmit}
          onKeyPress={(event) => {
            if (event.key == 'Enter') event.preventDefault();
          }}
        >
          <Input
            required
            label="Reasoning"
            placeholder="Enter reasoning"
            name="reasoning"
            type="textarea"
            control={control}
            width="300px"
            marginBottom={20}
            marginRight={30}
            margin="0 auto 40px"
            height="300px"
          />
          <FlexContainer justifyContent="flex-end" gap="20px">
            <Button
              style={{ padding: '5px' }}
              width="max-content"
              variant="danger"
              onClick={() => close(false)}
            >
              Close
            </Button>
            <Button style={{ padding: '5px' }} width="max-content" type="submit">
              Submit
            </Button>
          </FlexContainer>
        </form>
      </FlexContainer>
    </ModalContainer>
  );
}
